import "./resizeObserverFix"; // Must be first — patches ResizeObserver before any lib loads
import React from "react";
import ReactDOM from "react-dom";
import App from "./App";
import * as serviceWorker from "./serviceWorker";
import  JiraReportComponent from "./components/ReportIssue/JiraReportComponent";
import "./bootstrap.min.css";
// import "./font-awesome.min.css";
// import "./fonts.css";

import "./components.css";
import "./style.css";
import "./external.css";
import "./index.css";

import "react-bootstrap-table-next/dist/react-bootstrap-table2.min.css";
import "react-bootstrap-table2-toolkit/dist/react-bootstrap-table2-toolkit.min.css";

ReactDOM.render(
    <App />
  ,
  document.getElementById("root")
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
